module.exports = __webpack_public_path__ + "img/map.7201694a.svg";